import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const underTwentyFiveTaxNoApplyOrLimit = atom({
  key: "underTwentyFiveTaxNoApply",
  default: "noApply",
  effects_UNSTABLE: [ocPersistAtom],
});
